import axios from 'axios';

// URL de la API
const API_URL = process.env.REACT_APP_API_URL + '/auth';

export const login = async (usuario, contrasena) => {
    try {
        // 1. Enviamos un objeto JSON directo (sin FormData)
        const response = await axios.post(`${API_URL}/login`, {
            usuario: usuario,     
            contrasena: contrasena 
        });
        
        // 2. En nuestro nuevo Backend, el token se llama 'token' (no 'access_token')
        if (response.data.token) {
            localStorage.setItem('userToken', response.data.token);
        }
        
        return response.data;
    } catch (error) {
        // Manejamos el error que viene de Hono/Zod
        const errorMsg = error.response?.data?.error || 'Error de conexión con el servidor';
        throw errorMsg;
    }
};

export const logout = () => {
    //Borramos todos los rastros del usuario al hacer logout
    localStorage.removeItem('userToken');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_rol');
    localStorage.removeItem('user_name');

    window.location.href = '/login';
};

// Para cambio de clave
export const cambiarPassword = async (userId, token, passActual, passNueva) => {
    try {
        const response = await axios.post(
            `${API_URL}/${userId}/cambiar-password`, 
            { password_actual: passActual, password_nueva: passNueva },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        const errorMsg = error.response?.data?.error || 'Error al conectar con el servidor';
        throw errorMsg;
    }
};